import { render, staticRenderFns } from "./modal-feedback.vue?vue&type=template&id=d3dd35ce&scoped=true"
import script from "./modal-feedback.vue?vue&type=script&lang=js"
export * from "./modal-feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dd35ce",
  null
  
)

export default component.exports